export enum DesignTheme {
    CARTOON = 'Cartoon',
    GAMING = 'Gaming',
    CODING = 'Coding',
    SCIFIANDFANTACY = 'Sci-Fi & Fantacy',
    MEMECULTURE = 'Meme Culture',
    ANIME = 'Anime'
}
